import React, { useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { InfoContext } from "../providers/InfosContextProvider";

const logo = process.env.PUBLIC_URL + "/assets/images/casas-do-nabao-logo.png";
const portugalFlag = process.env.PUBLIC_URL + "/assets/images/pt.png";
const enFlag = process.env.PUBLIC_URL + "/assets/images/en.png";

const Header = () => {
  const { texts, language, setLanguage } = useContext(InfoContext);
  const nextLanguage = language === "PT" ? "EN" : "PT";
  const nextFlag = nextLanguage === "PT" ? portugalFlag : enFlag;
  const nextLanguageLabel =
    nextLanguage === "PT" ? texts.header.pt : texts.header.en;

  return (
    <header className="header fixed-top">
      <Navbar expand="lg" className="d-flex align-items-center">
        <Container fluid>
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <img className="logo-main" src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navmenu" />
          <Navbar.Collapse id="navmenu">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" className="nav-link">
                {texts.header.primeiro}
              </Nav.Link>

              <Nav.Link as={Link} to="/properties" className="nav-link">
                {texts.header.segundo}
              </Nav.Link>

              <Nav.Link as={Link} to="/sell" className="nav-link">
                {texts.header.quarto}
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/properties?transaction=arrendar"
                className="nav-link"
              >
                {texts.header.sexto}
              </Nav.Link>

              <Nav.Link as={Link} to="/contact" className="nav-link">
                {texts.header.terceiro}
              </Nav.Link>

              <Nav.Link as={Link} to="/about" className="nav-link">
                {texts.header.quinto}
              </Nav.Link>

              <Nav.Link as={Link} to="/news" className="nav-link">
                {texts.header.setimo}
              </Nav.Link>

              <button
                type="button"
                className="language-toggle"
                onClick={() => setLanguage(nextLanguage)}
                aria-label={nextLanguageLabel}
              >
                <img
                  src={nextFlag}
                  alt={nextLanguageLabel}
                  width="20"
                  height="20"
                />
              </button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
